<!-- Page -->
<div class="login-page">
  <div class="login-wrapper">

    <!-- Panel izquierdo: imagen de fondo + marca -->
    <div class="login-brand-panel d-none d-md-flex">
      <img src="./assets/img/media/login-2.png" class="login-bg-img" alt="C&M clínica">
      <div class="login-bg-overlay"></div>
      <div class="login-brand-inner">
        <img src="./assets/img/brand/logocm.png" class="login-brand-logo" alt="C&M logo">
        <h2 class="login-brand-name">C&M Imágenes<br>Medicina y Salud</h2>
        <p class="login-brand-tagline">"Tu aliado en el diagnóstico eficaz"</p>
        <div class="login-brand-services">
          <span>Radiografías</span>
          <span>Tomografías</span>
          <span>Ecografías</span>
          <span>Laboratorio</span>
        </div>
      </div>
    </div>

    <!-- Panel derecho: formulario -->
    <div class="login-form-panel">
      <div class="login-form-container">

        <!-- Logo solo en móvil -->
        <div class="d-flex d-md-none justify-content-center mb-4">
          <img src="./assets/img/brand/logocm.png" class="login-logo-mobile" alt="logo">
        </div>

        <div class="login-form-header">
          <h2 class="login-title">¡Bienvenido de nuevo!</h2>
          <p class="login-subtitle">Por favor inicie sesión para continuar.</p>
        </div>

        <form [formGroup]="loginForm" (ngSubmit)="Submit()" class="login-form">

          <div class="login-field">
            <label class="login-label">Usuario</label>
            <input
              class="login-input"
              placeholder="Ingrese su usuario"
              type="text"
              formControlName="usuario"
              autocomplete="username">
          </div>

          <div class="login-field">
            <label class="login-label">Clave</label>
            <div class="login-password-wrapper">
              <input
                class="login-input login-password-input"
                placeholder="Ingrese su clave"
                [type]="showPassword ? 'text' : 'password'"
                formControlName="password"
                autocomplete="current-password">
              <button
                type="button"
                class="login-password-toggle"
                [attr.aria-label]="showPassword ? 'Ocultar clave' : 'Mostrar clave'"
                [attr.title]="showPassword ? 'Ocultar clave' : 'Mostrar clave'"
                (click)="togglePasswordVisibility()">
                <i [class]="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
              </button>
            </div>
          </div>

          <div class="login-field">
            <label class="login-label">Sucursal</label>
            <ng-select class="login-select" formControlName="sucursales" [clearable]="false">
              <ng-option value="" selected>Seleccione una sucursal...</ng-option>
              @for (obj of _arraySucursales; track obj) {
                <ng-option [value]="obj.COD_SURC">{{ obj.DIR_SURC }}</ng-option>
              }
            </ng-select>
          </div>

          @if (spinnerBoolean) {
            <div class="login-spinner">
              <div class="spinner-border spinner-border-sm" role="status">
                <span class="sr-only">Cargando...</span>
              </div>
              <span>Verificando credenciales...</span>
            </div>
          }

          <button class="login-btn" type="submit" [disabled]="!loginForm.valid || spinnerBoolean">
            INGRESAR
          </button>

        </form>

      </div>
    </div>

  </div>
</div>
<!-- End Page -->
